// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardV1ActivateCardDefaultResponse {
    static getAttributeTypeMap() {
        return CardV1ActivateCardDefaultResponse.attributeTypeMap;
    }
}
CardV1ActivateCardDefaultResponse.discriminator = undefined;
CardV1ActivateCardDefaultResponse.additionalProperties = false;
CardV1ActivateCardDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
];
//# sourceMappingURL=cardV1ActivateCardDefaultResponse.js.map